// import BgVideo from "../../Assets/Hero-Vedio.mp4";

// const HeroSection = () => {
//   return (
//     <div className="relative w-full h-[400px] sm:h-[500px] lg:h-[650px] overflow-hidden bg-black">
//       {/* Video Background */}
//       <video
//         className="absolute inset-0 w-full h-full object-cover"
//         src={BgVideo}
//         autoPlay
//         loop
//         muted
//         playsInline
//         preload="metadata"
//       />

//       <div>
//         <h1>Building Intelligent AI Solutions for the Future</h1>
//         <p>We help businesses grow with AI-powered analytics, automation, development, and smart integrations — designed to scale with innovation.</p>
//       </div>

//       {/* Dark Overlay for better content visibility */}
//       <div className="absolute inset-0 bg-black/30" />
//     </div>
//   );
// };

// export default HeroSection;


import BgVideo from "../../Assets/Hero-Vedio.mp4";

const HeroSection = () => {
  return (
    <div className="relative w-full h-[400px] sm:h-[500px] lg:h-[650px] overflow-hidden bg-black">
      
      {/* Video Background */}
      <video
        className="absolute inset-0 w-full h-full object-cover"
        src={BgVideo}
        autoPlay
        loop
        muted
        playsInline
        preload="metadata"
      />

      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-black/50 z-10" />

      {/* Hero Content */}
      <div className="relative z-20 h-full flex items-center justify-center px-6">
        <div className="max-w-4xl text-center text-white">
          
          <h1 className="text-3xl sm:text-4xl lg:text-6xl font-bold leading-tight tracking-tight font-jakarta">
            Building Intelligent{" "}
            <span className="text-indigo-400">AI Solutions</span>{" "}
            for the Future
          </h1>

          <p className="mt-6 text-base sm:text-lg lg:text-xl text-gray-200 leading-relaxed">
            We help businesses grow with AI-powered analytics, automation,
            development, and smart integrations — designed to scale with
            innovation.
          </p>

          {/* Buttons */}
          <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center">
            <button className="px-8 py-3 rounded-full bg-indigo-600 hover:bg-indigo-700 transition font-medium">
              Get Started
            </button>

            <button className="px-8 py-3 rounded-full border border-white/40 hover:bg-white/10 transition font-medium">
              Talk to Our Experts
            </button>
          </div>

        </div>
      </div>
    </div>
  );
};

export default HeroSection;
